import { CampusName } from '@/components/common/output/campus';
import type { Column } from '@/components/common/table';
import type { Group, GroupTypeKey } from '@/shared/types/group';
import {
  Dropdown,
  DropdownTrigger,
  Button,
  DropdownMenu,
  DropdownItem,
  Tooltip,
} from '@heroui/react';
import { getGroupAlias, getGroupProperty } from './utils';
import { GroupName, GroupOversights } from '@/components/common/output/group';
import { Icon } from '@iconify/react/dist/iconify.js';

export type ActionKey = 'edit' | 'archive';

export type ColumnKey =
  | 'title'
  | 'campus'
  | 'type'
  | 'parent'
  | 'oversight'
  | 'actions';

export interface LayGroupColumn extends Column<Group> {
  key: ColumnKey;
}

export function makeColumns({
  type,
  onAction,
}: {
  type: '' | GroupTypeKey;
  onAction: (item: Group, action: ActionKey) => void;
}) {
  const columns: LayGroupColumn[] = [
    {
      key: 'title',
      label: 'Title',
      display: ({ item }: { item: Group; column: Column<Group> }) => (
        <div>{item.data.title}</div>
      ),
    },
    {
      key: 'campus',
      label: 'Campus',
      display: ({ item }: { item: Group; column: Column<Group> }) => (
        <CampusName id={item.data.campus_id} />
      ),
    },
    {
      key: 'type',
      label: 'Type',
      display: ({ item }: { item: Group }) => (
        <Tooltip content={getGroupAlias(item.data.type, 'type')}>
          <Icon
            icon={getGroupProperty(item.data.type, 'icon')}
            width={20}
            className='text-default-700'
          />
        </Tooltip>
      ),
    },
    {
      key: 'parent',
      label: 'Parent',
      display: ({ item }: { item: Group }) => (
        <GroupName id={item.data.parent_id} />
      ),
    },
    {
      key: 'oversight',
      label: type === '' ? 'Oversight' : getGroupAlias(type, 'oversight', true),
      display: ({ item }: { item: Group }) => <GroupOversights item={item} />,
    },
    {
      key: 'actions',
      label: '',
      display: ({ item }: { item: Group }) => {
        return (
          <Dropdown>
            <DropdownTrigger>
              <Button isIconOnly variant='light'>
                <Icon
                  icon='mdi:dots-vertical'
                  width={22}
                  height={22}
                  className='text-gray-600'
                />
              </Button>
            </DropdownTrigger>
            <DropdownMenu>
              <DropdownItem key='edit' onPress={() => onAction(item, 'edit')}>
                Edit
              </DropdownItem>
              <DropdownItem
                key='archive'
                onPress={() => onAction(item, 'archive')}
              >
                Archive
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        );
      },
    },
  ];

  return columns;
}
